export const getOrderAuthTags = (orderData = {}) => {
  const tagKeys = [ "to_risk_type", "to_fisdom_category_v2", "to_fisdom_subcategory_v2"]
  const tags = tagKeys.map(tagKey => orderData[tagKey] && orderData[tagKey].toUpperCase());
  return tags
}